export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '0 đ';
  }
  return `${new Intl.NumberFormat('vi-VN').format(Math.round(n))} đ`;
}

export function parseMoneyVn(input) {
  if (input == null) {
    return null;
  }

  let s = String(input).trim().toLowerCase().replace(/\s+/g, '');
  if (!s) {
    return null;
  }

  s = s.replace(/^[+-]/, '');

  const trMatch = s.match(/^(\d+(?:[.,]\d+)?)tr(\d*)$/i);
  if (trMatch) {
    const millions = parseFloat(trMatch[1].replace(',', '.'));
    const rest = trMatch[2] ? parseInt(trMatch[2].padEnd(6, '0').slice(0, 6), 10) : 0;
    const amount = millions * 1_000_000 + rest;
    return amount > 0 ? amount : null;
  }

  if (/^\d+(?:[.,]\d+)?k$/i.test(s)) {
    const amount = parseFloat(s.replace(/k$/i, '').replace(',', '.')) * 1000;
    return amount > 0 ? amount : null;
  }

  const digits = s.replace(/\./g, '').replace(/,/g, '');
  if (!/^\d+(\.\d+)?$/.test(digits) && !/^\d+$/.test(digits)) {
    const cleaned = s.replace(/[^\d]/g, '');
    const amount = parseFloat(cleaned);
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  }

  const amount = parseFloat(digits);
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}

export function formatDateVi(iso) {
  if (!iso) {
    return '';
  }
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

export function todayIso() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
